import React, { useContext, useEffect } from 'react'
import { IUserProfile } from '../../types/User/IUserProfile';
import { RevUserContext } from '../../context/UserContext';
import { trimChar } from '../../utils/utils';
import { nanoid } from 'nanoid';
import { useGetTenantQuery } from '../../redux/api/BaseApi';

const SessionKeepAlive = () => {
    const [random, setRandom] = React.useState<string>()
    const profile = useContext<IUserProfile>(RevUserContext);
    const { data: tenant } = useGetTenantQuery();
    const pingUrl = trimChar(tenant?.Tenant_Url, '/') + "/account/sessionkeepalive?r=" + random;

    useEffect(() => {
        //console.log('SessionKeepAlive setup ping', pingUrl)
        var ping = window.setInterval(() => {
            //console.log('ping', pingUrl)
            setRandom(nanoid())
        }, 60000)

        return () => {
            ping && window.clearInterval(ping);
        }
    }, [])

    return !profile || !random || !tenant
        ? <></>
        : (
            <iframe title='SessionKeepAlive' name='SessionKeepAlive' src={pingUrl} width={'0px'} height={'0px'} className='display-none hidden'></iframe>
        )
}

export default SessionKeepAlive